import { inject, Injectable } from "@angular/core";
import { CanActivate } from "@angular/router";
import { ProductService } from "src/app/services/product.service";
import { SoftwareProduct } from "src/app/support/product";
import { Auth } from "aws-amplify";
import { sntLog } from "src/app/common/logger";

let IN_MEMORY_STORAGE: Record<string, string> = {};

const logger = sntLog("ConfigureAuthForDropPageGuard");

@Injectable()
export class ConfigureAuthForDropPageGuard implements CanActivate {
  readonly #productService = inject(ProductService);

  async canActivate(): Promise<boolean> {
    logger.debug("canActivate");

    switch (this.#productService.getCurrentProduct()) {
      case SoftwareProduct.PMS:
      case SoftwareProduct.ROCKET:
      case SoftwareProduct.SNOOTS:
      case SoftwareProduct.ADMIN:
      case SoftwareProduct.PLATFORM:
      case SoftwareProduct.BOTMASTER: {
        return true;
      }
      case SoftwareProduct.DROP_PAGE: {
        await Auth.signOut();
        logger.debug("Auth.signOut");

        Auth.configure({
          storage: <Storage>{
            clear: () => {
              IN_MEMORY_STORAGE = {};
            },
            getItem: (key: string) => {
              return IN_MEMORY_STORAGE[key];
            },
            key: () => {
              return null;
            },
            length: 0,
            removeItem: (key: string) => {
              delete IN_MEMORY_STORAGE[key];
            },
            setItem: (key: string, value: string) => {
              IN_MEMORY_STORAGE[key] = value;
            }
          }
        });
        logger.debug("Auth configured");

        return true;
      }
    }
  }
}
